function eventEmitter () {
  const list = new Map<string, Function[]>()
  const onceList = new Map<string, Function[]>()

  return {
    on (event: string, callback: Function) {
      list.has(event) || list.set(event, [])
      list.get(event)!.push(callback)
      return this
    },

    off (event: string, callback: Function) {
      list.has(event) || list.set(event, [])
      list.set(event, list.get(event)!.filter(cb => cb !== callback))
      return this
    },

    once (event: string, callback: Function) {
      onceList.has(event) || onceList.set(event, [])
      onceList.get(event)!.push(callback)
      return this
    },

    emit (event: string, ...args: any[]) {
      if (!list.has(event) && !onceList.has(event)) return false

      if (list.has(event)) {
        for (const callback of list.get(event)!) {
          setTimeout(() => callback.call(this, ...args), 0)
        }
      }

      if (onceList.has(event)) {
        for (const callback of onceList.get(event)!) {
          setTimeout(() => callback.call(this, ...args), 0)
        }
        onceList.delete(event)
      }
      return true
    }
  }
}

export default eventEmitter
